module.exports = __webpack_public_path__ + "images/pages/for_business/sp/logo_7fcaf38ebbe44f28e106c449981a588d.png";